import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse } from '../models';
import { UploadsDrawingsService } from './uploads-drawings.service';
import { Router } from '@angular/router';
import { BehaviorSubject, take } from 'rxjs';
import { QuestinoryService } from './questinory.service';

// interface Permissions {
//   permissionId: number,
//   permissionName: string,
//   descriptionEn: string,
//   descriptionAr: string,
//   classificationId: number,
//   canBeDelegated: any | null
// }

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  private uploadService = inject(UploadsDrawingsService);
  private router = inject(Router);
  private questionaryService = inject(QuestinoryService);
  private userImageChangeSubject = new BehaviorSubject<void>(undefined);

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  logListEnums() {
    return [{
      name: "FileCreated",
      value: 1,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/architectural-drawing/drawing/' + param]);
      }
    },
    {
      name: "FileUpdated",
      value: 2,
      click: (fileId = null) => {
        if (!fileId) return;

        this.uploadService.GetFileById(fileId)
          .pipe(take(1))
          .subscribe((res: any) => {
            if (res['status']) {
              // this.fileUploadDetail = res['data'];
              let drawing = res['data'] || {};
              drawing.tabName = 'profile';
              drawing.isEdit = true;
              this.router.navigate(['/main/architectural-drawing/drawing'],{queryParams:{...drawing}});
              // router.navigate(['/main/architectural-drawing/drawing'], {queryParams:{tabName: 'profile', isEdit: true, ...drawing}})
              // this.uploadService.switchTab(drawing);
            }
          });
      }
    },
    {
      name: "FileDeleted",
      value: 3
    },
    {
      name: "FileReUploaded",
      value: 4,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/architectural-drawing/drawing/' + param]);
      }
    },
    {
      name: "AIAnalysisTriggered",
      value: 5,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/architectural-drawing/drawing/' + param]);
      }
    },
    {
      name: "AIAnalysisCompleted",
      value: 6,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/architectural-drawing/drawing/' + param]);
      }
    },
    {
      name: "AIAnalysisFailed",
      value: 7,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/architectural-drawing/drawing/' + param]);
      }
    },
    {
      name: "UserCreated",
      value: 8,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/users/users/view/' + param]);
      }
    },
    {
      name: "UserUpdated",
      value: 9,
      click: (param = null) => {
        if (!param) return;
        this.router.navigate(['/main/users/users/edit/' + param]);
      }
    },
    {
      name: "UserDeleted",
      value: 10
    },
    {
      name: "RoleCreated",
      value: 11,
      click: (param: number | null = null) => {
        if (!param) return;
        this.router.navigate(['/main/admin-config/roles/view/' + param]);
      }
    },
    {
      name: "RoleUpdated",
      value: 12,
      click: (param: number | null = null) => {
        if (!param) return;
        this.router.navigate(['/main/admin-config/roles/view/' + param]);
      }
    },
    {
      name: "RoleDeleted",
      value: 13
    },
    {
      name: "QuestionnaireCreated",
      value: 14,
      click: (param = null) => {
        if (!param) return;

        this.questionaryService.getQuestionnaireDetails(param).pipe(take(1)).subscribe((res: any) => {
          if (res['status']) {
            let drawing = res['data'];
            let data = {
              ...drawing,
              isView: true
            }

            this.router.navigate(['/main/questinory-management/questinory/view'],
              {
                queryParams: data
              }
            );
          }
        });

        // this.router.navigate(['/main/questinory-management/questinory/create']);
      }
    },
    {
      name: "QuestionnaireUpdated",
      value: 15,
      click: (param = null) => {
        if (!param) return;

        this.questionaryService.getQuestionnaireDetails(param).pipe(take(1)).subscribe((res: any) => {
          if (res['status']) {
            let drawing = res['data'];
            let val = {
              ...drawing,
              isEdit: true
            }

            this.router.navigate(['/main/questinory-management/questinory/view'],
              {
                queryParams: val
              }
            );
          }
        });

      }

    },
    {
      name: "QuestionnaireDeleted",
      value: 16
    },
    {
      name: "UserLoggedIn",
      value: 17
    }
    ]
  }

  sendUserImageRefresh(){
    this.userImageChangeSubject.next();
  }
  getUserImageRefresh(){
    return this.userImageChangeSubject.asObservable();
  }

  getIsClick(actionType: number) {
    const actions = this.logListEnums() || [];
    const found = actions.find((x: any) => x.value == actionType);
    return !!(found && Object.prototype.hasOwnProperty.call(found, 'click'));
  }

  getRouterLinkByActionType(actionType: number, parentId?: null) {
    const actions = this.logListEnums() || [];
    const found = actions.find((x: any) => x.value == actionType);
    if (!found || !found?.click) return;

    return found?.click(parentId);
  }

  getUsers(body: any) {

    const pageIndex = body.pageIndex || 0;
    const pageSize = body.pageSize || 10;

    // const params = new HttpParams()
    //   .set('pageIndex', pageIndex.toString())
    //   .set('pageSize', pageSize.toString());

    const link = this.apiUrl + ApiUrls.getUsers;
    return this.http.post(link, body);
  }


  getAllUsers() {
    const link = this.apiUrl + ApiUrls.getUsers;
    return this.http.get(link);
  }

  getUser(id: number) {
    const link = this.apiUrl + ApiUrls.getUser + '/' + id;
    return this.http.get<any>(link);
  }


  getPermissions() {
    const link = this.apiUrl + ApiUrls.getAllPermissions;
    return this.http.get<any>(link);
  }

  getAllDelegatablePermission() {
    const link = this.apiUrl + ApiUrls.getAllDelegatablePermissions;
    return this.http.get<any>(link);
  }

  insertUser(body: any) {
    const link = this.apiUrl + ApiUrls.insertUser;
    return this.http.post<BaseResponse>(link, body);
  }

  validateUserMail(body: any) {
    const link = this.apiUrl + ApiUrls.validateInvitedUser;
    return this.http.post<BaseResponse>(link, body);
  }

  inviteUser(body: any) {
    const link = this.apiUrl + ApiUrls.inviteUser;
    return this.http.post<BaseResponse>(link, body);
  }

  updateUser(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateUser}/${id}`;
    return this.http.post<BaseResponse>(link, body);
  }

  deleteUser(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteUser}/${id}`;
    return this.http.get<BaseResponse>(link);
  }

  getRoles(body: any) {
    const link = this.apiUrl + ApiUrls.getRoles;
    return this.http.post<any>(link, body);
  }

  getRoleById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getRoleById}/${id}`;
    return this.http.get<any>(link);
  }

  insertRole(body: any) {
    const link = this.apiUrl + ApiUrls.insertRole;
    return this.http.post<BaseResponse>(link, body);
  }
  updateRole(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateRole}/${id}`;
    return this.http.post<any>(link, body);
  }
  updateRoleAndPermission(body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateRole}`;
    return this.http.post<any>(link, body);
  }
  getDelegationToken(body: any) {
    const link = this.apiUrl + ApiUrls.getDelegationToken;
    return this.http.post<any>(link, body);
  }

  deleteRole(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteRole}/${id}`;
    return this.http.post<BaseResponse>(link, { id });
  }

  getUserPermissions(body: any) {
    const link = this.apiUrl + ApiUrls.getUserPermissions;
    return this.http.post<any>(link, body);
  }

  getUserPermission(id: number) {
    const link = this.apiUrl + ApiUrls.getUserPermission;
    return this.http.post<any>(link, { id });
  }

  deleteUserPermission(id: number) {
    const link = this.apiUrl + ApiUrls.deleteUserPermission;
    return this.http.post<any>(link, { id });
  }

  getUserNotification(id: any) {
    const link = this.apiUrl + ApiUrls.getUserNotification;
    return this.http.post<any>(link, id);
  }

  updateUserNotification(body: any) {
    const link = this.apiUrl + ApiUrls.updateUserNotification;
    return this.http.post<any>(link, body);
  }

  resetNewUserPassword(body: any) {
    const link = this.apiUrl + ApiUrls.resetUserPassword;
    return this.http.post<any>(link, body);
  }

  logList(body: any) {
    const link = this.apiUrl + ApiUrls.logList;
    return this.http.post<any>(link, body);
  }

  GetAllFilesByCurrentUser(value: any) {
    const link = this.apiUrl + ApiUrls.UserManagement.GetAllFilesByCurrentUser;
    return this.http.post<any>(link, value);
  }

  updateUserImage(id: any, val: any) {
    const link = this.apiUrl + ApiUrls.updateUserImage;
    return this.http.post<any>(link + id, val);
  }

  getUserImage(userid: any) {
    const link = this.apiUrl + ApiUrls.getUserImage;
    return this.http.get(link + userid, {
      responseType: 'blob'
    });
  }

}
